import { useOrgContext } from '@/org/contexts/OrgContext'
import { useMemo } from 'react'
import { MemberProposal, proposeMember } from '../proposedMember'

// The member to propose for a role, from the org's current holders (#123).
export default function useMemberProposal(
  circleId: string | undefined
): MemberProposal | undefined {
  const { orgData } = useOrgContext()
  return useMemo(() => {
    if (!circleId || !orgData) return undefined
    return proposeMember(
      orgData
        .membersOf(circleId)
        .map(({ member }) => ({ id: member.id, name: member.name }))
    )
  }, [orgData, circleId])
}
